import type {
    default as CalendarPickerStoreByScenario,
    CalendarPickerStore,
} from './schema/CalendarPickerStore';
import type CalendarPickerScenarioId from './schema/CalendarPickerScenarioId';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import '../mutators/setCondensedCalendarsMutator';

export const createDefaultCalendarPickerStore = (): CalendarPickerStore => {
    return {
        contextMenu: null,
        newCalendarInCalendarGroup: null,
        accountCreatingCalendarGroup: null,
        collapsedCalendarGroups: new ObservableMap<string, true>(),
        collapsedCalendarAccounts: new ObservableMap<string, true>(),
        condensedCalendarAccounts: new ObservableMap<string, true>(),
        condensedViewCalendars: new ObservableMap<string, string[]>(),
        expandedCalendarsForCalendarGroup: new ObservableMap<string, true>(),
        renamingItemId: null,
        draggedItemData: null,
    };
};

export const calendarPickerStore: CalendarPickerStoreByScenario = {
    scenarioStores: new ObservableMap<CalendarPickerScenarioId, CalendarPickerStore>(),
};

export const getStore = createStore<CalendarPickerStoreByScenario>(
    'calendarPickerStore',
    calendarPickerStore
);
export default getStore;
